/**
 * components/landing/ai-platform/sections/EnterpriseAI.jsx — §4.9.
 * Six enterprise-grade AI qualities.
 */

import React from 'react'
import { Compass, ShieldCheck, Lock, Layers, FolderCog, Plug, Sparkles } from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import { ENTERPRISE } from '../data'
import { TONE } from '../_shared'

const ICONS = { Compass, ShieldCheck, Lock, Layers, FolderCog, Plug }

export default function EnterpriseAI() {
  return (
    <section className="relative py-24 md:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>Enterprise AI</Eyebrow>
          <SectionHeading
            align="center"
            title={<>AI that <span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">passes procurement.</span></>}
            subtitle="Every AI capability inherits the platform’s security, tenancy, RBAC and audit posture. Nothing is bolted on — the AI is part of the platform, not adjacent to it."
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {ENTERPRISE.map((e) => {
            const tone = TONE[e.tone] || TONE.orange
            const Icon = ICONS[e.iconKey] || Sparkles
            return (
              <div key={e.id} className="relative rounded-2xl border border-white/10 bg-white/[0.02] p-5 backdrop-blur-xl transition-all hover:border-white/20 hover:bg-white/[0.03] overflow-hidden">
                <div className="pointer-events-none absolute inset-0 opacity-40"
                  style={{ background: `radial-gradient(80% 40% at 20% 0%, rgba(${tone.rgb},0.10), transparent 70%)` }} />
                <div className="relative flex flex-col gap-3">
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl border"
                    style={{ borderColor: `rgba(${tone.rgb},0.35)`, background: `rgba(${tone.rgb},0.08)`, color: tone.hex }}>
                    <Icon strokeWidth={1.8} style={{ width: 18, height: 18 }} />
                  </span>
                  <div>
                    <h4 className="text-base font-semibold text-white leading-tight">{e.label}</h4>
                    <p className="text-sm text-zinc-400 leading-relaxed mt-1">{e.body}</p>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </Container>
    </section>
  )
}
